export class ContactDetails {
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  zipExtension: string;
  phone: string;
  email: string;
  emailAddress: string;
  county: string;
  fax: string;
  id: number;
  name: string;
  locationTypeId: number;

  constructor(
    address1: string = "",
    address2: string = "",
    city: string = "",
    state: string = "",
    zip: string = "",
    zipExtension: string = "",
    phone: string = "",
    email: string = "",
    emailAddress: string = "",
    county: string = "",
    fax: string = ""
  ) {
    this.address1 = address1;
    this.address2 = address2;
    this.city = city;
    this.state = state;
    this.zip = zip;
    this.zipExtension = zipExtension;
    this.phone = phone;
    this.email = email;
    this.emailAddress = emailAddress;
    this.county = county;
    this.fax = fax;
  }

  static clone = (clone: ContactDetails): ContactDetails => {
    let c = new ContactDetails();
    c.address1 = clone.address1;
    c.city = clone.city;
    c.state = clone.state;
    c.county = clone.county;
    c.zip = clone.zip;
    c.zipExtension = clone.zipExtension;
    c.locationTypeId = clone.locationTypeId;
    c.name = clone.name;
    c.phone = clone.phone;
    c.fax = clone.fax;
    c.emailAddress = clone.emailAddress;
    return c;
  };
}



// WEBPACK FOOTER //
// ./src/models/contact/contactDetails.ts